<script lang="ts">
	//UI
	import MultiplePageLayout from "@hitit/hub/src/layouts/MultiplePageLayout.svelte";
	import HubFaq from "./HubFaq.svelte";
	import HubPost from "./HubPost.svelte";
	import NoticeRouter from "@hitit/mbr/src/v7/Router/NoticeRouter.svelte";

	//Utils
	import { navigate, Router, Route } from "svelte-routing";
	import { t } from "@hitit/hub/src/stores";
	//Types
	//Props
	//Constants
	//Variables
	//Functions
	//Do

	$: headerInfos = [
		{
			title: $t("mbr.setting.faq"),
			clickEvent: () => navigate(`/hubsetting/faq`),
			route: `/hubsetting/faq/*`,
		},
		{
			title: $t("mbr.setting.post"),
			clickEvent: () => navigate(`/hubsetting/post`),
			route: `/hubsetting/post/*`,
		},
		{
			title: "What's new",
			clickEvent: () => navigate(`/hubsetting/notice`),
			route: `/hubsetting/notice/*`,
		},
	];

</script>

<MultiplePageLayout headerInfos={headerInfos}>
	<Router>
		<Route path="/faq">
			<HubFaq />
		</Route>
		<Route path="/post">
			<HubPost />
		</Route>
		<Route path="/notice/*">
			<NoticeRouter />
		</Route>
	</Router>
</MultiplePageLayout>

<style lang="scss">
</style>
